import { render, staticRenderFns } from "./TerritorioArgentina.vue?vue&type=template&id=50545568&scoped=true&lang=pug"
import script from "./TerritorioArgentina.vue?vue&type=script&lang=js"
export * from "./TerritorioArgentina.vue?vue&type=script&lang=js"
import style0 from "./TerritorioArgentina.vue?vue&type=style&index=0&id=50545568&prod&lang=scss&scoped=true"
import style1 from "./TerritorioArgentina.vue?vue&type=style&index=1&id=50545568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50545568",
  null
  
)

export default component.exports